var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.show ? _c('div', {
    staticClass: "popup_wrapper",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.wrapperClick();
      }
    }
  }, [_c('div', {
    staticClass: "popup",
    style: {
      top: _vm.y + 'px',
      left: _vm.x + 'px'
    }
  }, [_vm._t("default")], 2)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }